import { Dropdown, typography } from '@joor/design-system'
import styled from 'styled-components'

export const TemplateSelectorContainer = styled.div`
  margin-bottom: 16px;
  text-align: left;

  & > div > label {
    display: block;

    & > div:first-child {
      display: inline-block;
    }
  }
`

export const DownloadLink = styled.a`
  ${typography.alpha.primaryActive.body3}
  color: var(--color-secondary-800);
  font-weight: var(--font-weight-regular);
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`

export const StyledDropdown = styled(Dropdown)`
  margin-bottom: 8px;
  max-width: 60%;
  width: 100%;
`

export const FileInfoContainer = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 8px;
  ${typography.alpha.primaryActive.body3}

  &.success {
    color: var(--color-success-500);
  }

  &.error {
    color: var(--color-error-500);
  }
`

export const UploadFileTile = styled.span`
  margin-bottom: 4px;
  ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-900);
`
